import { Navigate, Outlet } from "react-router-dom";
import { isTokenExpired } from "./isTokenExpired"; 

export const ProtectedLayout = () => {
  const expired = isTokenExpired();

  return expired ? <Navigate to="/sign-in" /> : <Outlet />;
};
